import { render } from "./ChatGPT.vue?vue&type=template&id=740f9591"
import script from "./ChatGPT.vue?vue&type=script&lang=js"
export * from "./ChatGPT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__